// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project imports
import Profile from './Profile';
import ThemeModeToggle from './ThemeModeToggle';
import usePartnerAuth from 'hooks/usePartnerAuth';
import { usePortalConfig } from 'api/portal';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const { partner, user } = usePartnerAuth();
  const { config } = usePortalConfig();

  // The settings-managed Partner name is authoritative (exact casing included);
  // the auth partner slug only fills in while portal-config is still loading.
  const slugName = partner?.slug ? partner.slug.charAt(0).toUpperCase() + partner.slug.slice(1) : 'PrivacyPal';
  const partnerName = config?.partnerName || slugName;

  return (
    <>
      {!downMD && (
        <Stack sx={{ ml: 1 }}>
          <Typography variant="overline" color="primary" sx={{ lineHeight: 1.2 }}>
            Partner Portal
          </Typography>
          <Typography variant="h5" sx={{ lineHeight: 1.1 }}>
            {partnerName}
          </Typography>
        </Stack>
      )}
      <Box sx={{ flexGrow: 1 }} />
      {!downMD && user?.email && (
        <Chip label={user.email} variant="outlined" size="small" sx={{ mr: 1.5, borderColor: 'divider', color: 'text.secondary' }} />
      )}
      <ThemeModeToggle />
      <Profile />
    </>
  );
}
